<template>
    <search-group :title="'用户查询'"   @search="findData" @clear="clearValue" >
        <Row class="mb16" :gutter="16">
            <Col span="6">
              <Select v-model="searchData.projectFid" placeholder="请选择项目">
                <Option value=''>请选择</Option>
                <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="5">
              <Select v-model="searchData.empType" placeholder="请选择员工类型">
                <Option value=''>请选择</Option>
                <Option v-for="item in empTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.isProjectManager" placeholder="是否为项目经理">
                  <Option value=''>请选择</Option>
                  <Option v-for="item in isProjectManager" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Input type="text" v-model="searchData.pzoName" placeholder="姓名" @keyup.enter.native="findData"></Input>
            </Col>
            <Col span="4">
              <Input type="text" v-model="searchData.pzoEmpCode" placeholder="系统号" @keyup.enter.native="findData"></Input>
            </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">


import { conditionForZOlist } from 'api/managementCenter'
// import SearchGroup from 'components/SearchGroup/index';

export default {
    created(){
      this.initData()
      this.$emit('findData',this.searchData)
    },
    props:{
      projectList:{
        type:Array,
        default(){
          return []
        }
      },
      empTypeList:{
        type:Array,
        default(){
          return []
        }
      },
      isProjectManager:{
        type:Array,
        default(){
          return []
        }
      },

    },
    components: {
        // SearchGroup
    },
    data () {
      return {
        searchData:{
          projectFid:'',
          pzoEmpCode:'',
          pzoName:'',
          pzoPhone:'',
          empType:'',
          isProjectManager:'',
          limit: 10,
          page: 1
        }
      }
    },
    methods: {
      findData() {
        this.$emit('findData',this.searchData)
      },
      clearValue() {
        for (var key in this.searchData) {
          if(key === 'limit' || key === 'page') continue
          this.searchData[key] = ''
        }
      },
      initData(){

      }
    }
}
</script>
<style scoped>
.dash {
  text-align: center;
}
.dash span {
  display: inline-block;
  width: 60%;
  height: 2px;
  background: #dddee1;
  vertical-align: middle;
}
.ivu-date-picker {
  width: 100%;
}
</style>

